export const blogPosts5 = [
  {
    slug: "como-acessar-o-directadmin",
    title: "Como acessar o DirectAdmin passo a passo",
    h1: "Como acessar o DirectAdmin?",
    excerpt:
      "Veja como acessar o painel DirectAdmin da hospedagem, o que fazer se esquecer a senha e como resolver os problemas de acesso mais comuns.",
    metaTitle: "Como Acessar o DirectAdmin Passo a Passo | NXHOST",
    metaDescription:
      "Aprenda como acessar o DirectAdmin da sua hospedagem, recuperar a senha e resolver os erros de acesso mais comuns no painel.",
    focusKeyword: "como acessar o directadmin",
    keywords: ["como acessar o directadmin", "directadmin login", "painel directadmin", "acessar hospedagem"],
    category: "directadmin",
    level: "Iniciante",
    tags: ["DirectAdmin", "Hospedagem", "SSL"],
    author: "nxhost",
    publishedAt: "2026-05-04",
    updatedAt: "2026-09-10",
    readingTime: "6 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=web%20hosting%20login%20page%20displayed%20on%20a%20laptop%20screen%20in%20a%20bright%20tidy%20workspace%2C%20clean%20modern%20interface%20with%20brazilian%20portuguese%20labels%2C%20professional%20technology%20photography%2C%20soft%20neutral%20background&width=1200&height=675&seq=nx-blog-11&orientation=landscape",
    imageAlt: "Tela de login do painel DirectAdmin em um notebook",
    intro: [
      "O primeiro passo para gerenciar a sua hospedagem é acessar o painel DirectAdmin. Parece simples, mas muita gente trava justamente nessa etapa.",
      "Neste guia você aprende como acessar o DirectAdmin, o que fazer se esquecer a senha e como resolver os erros de acesso mais comuns.",
    ],
    content: [
      {
        id: "o-que-precisa",
        heading: "O que você precisa antes de acessar",
        level: 2,
        list: [
          "O endereço de acesso enviado pela hospedagem (normalmente seudominio.com.br:2222).",
          "O nome de usuário da hospedagem.",
          "A senha definida na contratação.",
        ],
      },
      {
        id: "como-acessar",
        heading: "Como acessar o DirectAdmin",
        level: 2,
        list: [
          "Abra o navegador e digite o endereço de acesso fornecido pela hospedagem.",
          "Aceite o aviso de certificado, se aparecer, durante a primeira conexão.",
          "Informe o usuário e a senha nos campos de login.",
          "Clique em entrar: o painel será exibido com os ícones de cada função.",
        ],
      },
      {
        id: "esqueci-senha",
        heading: "Esqueci a senha: como recuperar",
        level: 2,
        paragraphs: [
          "Se você esqueceu a senha, é possível redefini-la pelo painel do cliente da hospedagem ou solicitando ao suporte. Use sempre uma senha forte, com letras, números e caracteres especiais.",
        ],
      },
      {
        id: "problemas-comuns",
        heading: "Problemas comuns de acesso",
        level: 2,
        list: [
          "Endereço errado: confirme se o endereço inclui a porta correta.",
          "Usuário ou senha incorretos: revise os dados enviados na contratação.",
          "Bloqueio por tentativas: aguarde alguns minutos ou fale com o suporte.",
          "Firewall ou VPN: algumas redes bloqueiam portas específicas.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Acessar o DirectAdmin é o ponto de partida para administrar e-mails, bancos de dados, SSL e arquivos do seu site. Com o painel aberto, as tarefas do dia a dia ficam bem mais simples.",
        ],
      },
    ],
    faqs: [
      {
        question: "Qual é a porta padrão do DirectAdmin?",
        answer:
          "A porta mais comum é a 2222. Algumas hospedagens usam portas personalizadas, então confirme o endereço informado no seu painel de cliente.",
      },
      {
        question: "Não recebi os dados de acesso. O que faço?",
        answer:
          "Verifique a caixa de entrada e o spam do e-mail cadastrado. Se não encontrar, entre em contato com o suporte para reenviar os dados.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e encontre uma estrutura adequada para o seu projeto.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "como-criar-email-no-directadmin",
    title: "Como criar e-mail no DirectAdmin",
    h1: "Como criar e-mail no DirectAdmin?",
    excerpt:
      "Aprenda a criar, configurar e gerenciar contas de e-mail profissional no painel DirectAdmin, além de autoresposta e encaminhamento.",
    metaTitle: "Como Criar E-mail no DirectAdmin | Guia NXHOST",
    metaDescription:
      "Passo a passo para criar e-mail profissional no DirectAdmin, configurar autoresposta, encaminhamento e resolver problemas de envio.",
    focusKeyword: "como criar email no directadmin",
    keywords: ["criar email directadmin", "email profissional", "conta de email", "directadmin email"],
    category: "directadmin",
    level: "Iniciante",
    tags: ["DirectAdmin", "Hospedagem", "Domínio"],
    author: "nxhost",
    publishedAt: "2026-05-08",
    updatedAt: "2026-09-11",
    readingTime: "6 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=email%20management%20dashboard%20on%20a%20computer%20screen%20showing%20a%20list%20of%20professional%20email%20accounts%2C%20clean%20modern%20interface%20with%20brazilian%20portuguese%20labels%2C%20bright%20office%2C%20technology%20photography&width=1200&height=675&seq=nx-blog-12&orientation=landscape",
    imageAlt: "Painel de gerenciamento de contas de e-mail profissional",
    intro: [
      "Ter um e-mail com o domínio da sua empresa passa muito mais credibilidade do que usar endereços genéricos. No DirectAdmin, criar essa conta leva poucos minutos.",
      "Neste tutorial você aprende a criar e-mails, configurar autoresposta e encaminhamento e resolver problemas de envio.",
    ],
    content: [
      {
        id: "criar-email",
        heading: "Como criar um e-mail no DirectAdmin",
        level: 2,
        list: [
          "No painel, acesse a área de E-mail / Contas de E-mail.",
          "Clique em criar conta de e-mail.",
          "Digite o nome desejado (ex.: contato) e escolha o domínio.",
          "Defina uma senha forte e confirme.",
          "Salve: a conta já está pronta para uso.",
        ],
      },
      {
        id: "autoresposta",
        heading: "Configurando autoresposta",
        level: 2,
        paragraphs: [
          "A autoresposta envia uma mensagem automática para quem te escreve — útil para avisos de férias ou confirmação de recebimento. Basta habilitar a função na conta e escrever o texto da resposta.",
        ],
      },
      {
        id: "encaminhamento",
        heading: "Encaminhamento de mensagens",
        level: 2,
        paragraphs: [
          "Você pode encaminhar mensagens de um endereço para outro e-mail de destino. É uma forma útil de centralizar o atendimento quando há vários contatos.",
        ],
      },
      {
        id: "configurar-cliente",
        heading: "Configurando no seu programa de e-mail",
        level: 2,
        list: [
          "Servidor de entrada (IMAP/POP): conforme informado pela hospedagem.",
          "Servidor de saída (SMTP): usa autenticação com usuário e senha.",
          "Portas mais usadas: 587 (SMTP) e 993 (IMAP) com SSL.",
        ],
      },
      {
        id: "problemas",
        heading: "Problemas comuns de e-mail",
        level: 2,
        list: [
          "Mensagens caindo no spam: verifique SPF, DKIM e DMARC.",
          "Não envia: confira usuário, senha e porta de saída.",
          "Não recebe: revise os registros MX do domínio.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Criar um e-mail profissional no DirectAdmin é rápido e deixa a comunicação da sua empresa mais confiável. Com a conta configurada corretamente, você evita falhas de envio e recebimento.",
        ],
      },
    ],
    faqs: [
      {
        question: "Posso criar vários e-mails no mesmo domínio?",
        answer:
          "Sim. A quantidade depende do plano contratado. Você pode criar endereços como contato, vendas e financeiro no mesmo domínio.",
      },
      {
        question: "Por que meus e-mails vão para o spam?",
        answer:
          "Normalmente por falta de configuração de SPF, DKIM e DMARC. Esses registros de DNS ajudam a autenticar as mensagens e melhoram a entrega.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e tenha e-mail profissional com o domínio da sua empresa.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "como-criar-banco-de-dados-no-directadmin",
    title: "Como criar banco de dados MySQL no DirectAdmin",
    h1: "Como criar banco de dados no DirectAdmin?",
    excerpt:
      "Passo a passo para criar banco de dados e usuário MySQL no DirectAdmin e conectar ao seu site ou sistema com segurança.",
    metaTitle: "Como Criar Banco de Dados no DirectAdmin | NXHOST",
    metaDescription:
      "Aprenda a criar banco de dados e usuário MySQL no DirectAdmin, atribuir permissões e conectar ao site ou sistema corretamente.",
    focusKeyword: "como criar banco de dados no directadmin",
    keywords: ["banco de dados directadmin", "mysql directadmin", "criar usuario mysql", "phpmyadmin directadmin"],
    category: "directadmin",
    level: "Iniciante",
    tags: ["DirectAdmin", "MySQL", "Hospedagem"],
    author: "nxhost",
    publishedAt: "2026-05-12",
    updatedAt: "2026-09-12",
    readingTime: "7 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=database%20management%20interface%20on%20a%20monitor%20showing%20tables%20and%20mysql%20structure%2C%20clean%20professional%20software%20screen%20with%20brazilian%20portuguese%20labels%2C%20bright%20modern%20workspace&width=1200&height=675&seq=nx-blog-13&orientation=landscape",
    imageAlt: "Tela de gerenciamento de banco de dados MySQL",
    intro: [
      "Sites como WordPress, sistemas e lojas virtuais precisam de um banco de dados para funcionar. No DirectAdmin você cria esse banco em poucos passos.",
      "Neste tutorial você aprende a criar o banco, o usuário MySQL, atribuir permissões e conectar tudo ao seu projeto.",
    ],
    content: [
      {
        id: "criar-banco",
        heading: "Criando o banco de dados",
        level: 2,
        list: [
          "No painel, acesse a área de Bancos de Dados MySQL.",
          "Informe o nome do banco (ele receberá um prefixo).",
          "Defina o usuário e uma senha forte.",
          "Confirme a criação.",
        ],
      },
      {
        id: "permissoes",
        heading: "Atribuindo permissões ao usuário",
        level: 2,
        paragraphs: [
          "Depois de criar o banco e o usuário, é preciso vinculá-los. Selecione o usuário, o banco e conceda as permissões necessárias (geralmente todas as permissões para aplicações comuns).",
        ],
      },
      {
        id: "phpmyadmin",
        heading: "Gerenciando pelo phpMyAdmin",
        level: 2,
        paragraphs: [
          "Com o botão de acesso rápido, você abre o phpMyAdmin e gerencia as tabelas, importa ou exporta dados e executa consultas diretamente pelo navegador.",
        ],
      },
      {
        id: "conectar",
        heading: "Conectando o site ao banco",
        level: 2,
        list: [
          "Host do banco: normalmente localhost.",
          "Nome do banco: com o prefixo gerado no painel.",
          "Usuário e senha: os mesmos definidos na criação.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Criar um banco de dados no DirectAdmin é uma tarefa simples e essencial para colocar sites e sistemas no ar. Com o banco e o usuário configurados, basta conectar ao seu projeto.",
        ],
      },
    ],
    faqs: [
      {
        question: "Qual host devo usar para conectar o banco?",
        answer:
          "Na maioria das hospedagens compartilhadas, o host é localhost. Em alguns casos, o provedor informa um host específico.",
      },
      {
        question: "Posso ter mais de um banco de dados?",
        answer:
          "Sim. A quantidade depende do plano contratado. Você pode criar bancos separados para sites e sistemas diferentes.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e encontre uma estrutura adequada para sites, sistemas e lojas virtuais.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "como-instalar-ssl-no-directadmin",
    title: "Como instalar SSL no DirectAdmin (Let's Encrypt)",
    h1: "Como instalar SSL no DirectAdmin?",
    excerpt:
      "Veja como instalar um certificado SSL gratuito com Let's Encrypt no DirectAdmin e deixar o seu site seguro com HTTPS.",
    metaTitle: "Como Instalar SSL no DirectAdmin | Let's Encrypt | NXHOST",
    metaDescription:
      "Passo a passo para instalar certificado SSL no DirectAdmin usando Let's Encrypt e ativar o HTTPS no seu site com segurança.",
    focusKeyword: "como instalar ssl no directadmin",
    keywords: ["ssl directadmin", "lets encrypt directadmin", "https", "certificado ssl"],
    category: "directadmin",
    level: "Intermediário",
    tags: ["DirectAdmin", "SSL", "Hospedagem"],
    author: "nxhost",
    publishedAt: "2026-05-16",
    updatedAt: "2026-09-13",
    readingTime: "6 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=ssl%20certificate%20security%20setting%20interface%20on%20a%20laptop%20screen%20with%20a%20green%20padlock%20icon%2C%20clean%20modern%20dashboard%20with%20brazilian%20portuguese%20labels%2C%20bright%20tidy%20workspace&width=1200&height=675&seq=nx-blog-14&orientation=landscape",
    imageAlt: "Tela de configuração de certificado SSL no painel",
    intro: [
      "O cadeado ao lado do endereço do site transmite segurança e ainda ajuda no SEO. Em poucos cliques, você pode ativar o SSL gratuito no DirectAdmin.",
      "Neste tutorial você aprende como instalar e renovar o certificado com Let's Encrypt.",
    ],
    content: [
      {
        id: "por-que-ssl",
        heading: "Por que o site precisa de SSL?",
        level: 2,
        paragraphs: [
          "O SSL criptografa a comunicação entre o visitante e o servidor. Sites sem SSL aparecem como não seguros no navegador, o que afasta visitantes e prejudica a confiança e o posicionamento.",
        ],
      },
      {
        id: "instalar",
        heading: "Instalando o SSL com Let's Encrypt",
        level: 2,
        list: [
          "No painel, acesse a área de SSL / Certificados.",
          "Selecione o domínio desejado e escolha o certificado gratuito Let's Encrypt.",
          "Marque as opções para incluir o domínio com e sem www.",
          "Clique em salvar e aguarde a emissão.",
        ],
      },
      {
        id: "https",
        heading: "Forçando o uso de HTTPS",
        level: 2,
        paragraphs: [
          "Depois de emitir o certificado, ative a opção de redirecionar o tráfego para HTTPS. Assim, todos os acessos passam automaticamente para a versão segura do site.",
        ],
      },
      {
        id: "renovacao",
        heading: "Renovação do certificado",
        level: 2,
        paragraphs: [
          "Os certificados do Let's Encrypt têm validade curta e são renovados automaticamente. Ainda assim, vale conferir de tempos em tempos se a renovação está funcionando.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Instalar SSL no DirectAdmin é rápido e essencial para qualquer site. Com o HTTPS ativo, você protege os seus visitantes e melhora a credibilidade da sua empresa online.",
        ],
      },
    ],
    faqs: [
      {
        question: "O SSL do Let's Encrypt é gratuito?",
        answer:
          "Sim. O Let's Encrypt é uma autoridade certificadora gratuita e amplamente utilizada. A hospedagem faz a emissão e a renovação automática.",
      },
      {
        question: "Depois de instalar o SSL o site fica seguro automaticamente?",
        answer:
          "O SSL protege a conexão. A segurança completa do site também envolve senhas fortes, atualizações e boas práticas de desenvolvimento.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e tenha SSL, e-mail profissional e suporte incluso.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "como-fazer-backup-no-directadmin",
    title: "Como fazer e restaurar backup no DirectAdmin",
    h1: "Como fazer backup no DirectAdmin?",
    excerpt:
      "Aprenda a gerar, baixar e restaurar backups completos do site, e-mails e bancos de dados no painel DirectAdmin.",
    metaTitle: "Como Fazer Backup no DirectAdmin | NXHOST",
    metaDescription:
      "Passo a passo para gerar, baixar e restaurar backup no DirectAdmin, protegendo os arquivos, e-mails e bancos de dados do seu site.",
    focusKeyword: "como fazer backup no directadmin",
    keywords: ["backup directadmin", "restaurar backup", "backup hospedagem", "copia de seguranca"],
    category: "directadmin",
    level: "Intermediário",
    tags: ["DirectAdmin", "Hospedagem", "MySQL"],
    author: "nxhost",
    publishedAt: "2026-05-20",
    updatedAt: "2026-09-14",
    readingTime: "6 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=backup%20and%20restore%20settings%20interface%20on%20a%20computer%20screen%20with%20cloud%20storage%20icons%2C%20clean%20modern%20dashboard%20with%20brazilian%20portuguese%20labels%2C%20bright%20office%20workspace&width=1200&height=675&seq=nx-blog-15&orientation=landscape",
    imageAlt: "Painel de backup e restauração no DirectAdmin",
    intro: [
      "Backup é aquela tarefa que a gente só lembra quando algo dá errado. Mas é justamente ela que evita perder o site, os e-mails e os bancos de dados.",
      "Neste guia você aprende a gerar, baixar e restaurar um backup completo no DirectAdmin.",
    ],
    content: [
      {
        id: "por-que",
        heading: "Por que fazer backup",
        level: 2,
        paragraphs: [
          "Erros humanos, falhas de atualização, invasões e problemas no servidor podem comprometer o seu projeto. Um backup recente permite restaurar tudo rapidamente e com o mínimo de impacto.",
        ],
      },
      {
        id: "gerar",
        heading: "Gerando um backup no DirectAdmin",
        level: 2,
        list: [
          "Acesse a área de Backup / Criar backup.",
          "Escolha o que deseja incluir: arquivos, e-mails e bancos de dados.",
          "Inicie a geração e aguarde a conclusão.",
          "Baixe o arquivo .tar.gz para o seu computador ou armazenamento na nuvem.",
        ],
      },
      {
        id: "restaurar",
        heading: "Restaurando um backup",
        level: 2,
        list: [
          "Acesse a área de Backup / Restaurar.",
          "Selecione o arquivo de backup salvo anteriormente.",
          "Escolha o que deve ser restaurado.",
          "Confirme e aguarde a restauração.",
        ],
      },
      {
        id: "boas-praticas",
        heading: "Boas práticas de backup",
        level: 2,
        list: [
          "Gere backups com regularidade.",
          "Guarde as cópias fora do servidor (nuvem ou HD externo).",
          "Teste a restauração de vez em quando.",
          "Mantenha mais de uma versão guardada.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Fazer backup no DirectAdmin é simples e protege o seu maior ativo digital: o conteúdo e a estrutura do seu projeto. Com uma rotina de cópias, você dorme tranquilo.",
        ],
      },
    ],
    faqs: [
      {
        question: "Com que frequência devo fazer backup?",
        answer:
          "Depende da frequência com que o site muda. Sites e lojas com atualizações diárias se beneficiam de backups frequentes.",
      },
      {
        question: "O backup inclui os e-mails?",
        answer:
          "Sim. Você pode incluir contas de e-mail e suas mensagens na geração do backup, além dos arquivos e bancos de dados.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e conte com estrutura preparada para proteger o seu projeto.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "como-acessar-o-cpanel",
    title: "Como acessar o cPanel passo a passo",
    h1: "Como acessar o cPanel?",
    excerpt:
      "Veja como acessar o cPanel da sua hospedagem, o que fazer se esquecer a senha e como resolver os erros de login mais comuns.",
    metaTitle: "Como Acessar o cPanel Passo a Passo | NXHOST",
    metaDescription:
      "Aprenda como acessar o cPanel da sua hospedagem, recuperar a senha e resolver os erros de login mais comuns no painel.",
    focusKeyword: "como acessar o cpanel",
    keywords: ["como acessar o cpanel", "cpanel login", "painel cpanel", "acessar hospedagem"],
    category: "cpanel",
    level: "Iniciante",
    tags: ["cPanel", "Hospedagem", "Dominio"],
    author: "nxhost",
    publishedAt: "2026-05-24",
    updatedAt: "2026-09-15",
    readingTime: "6 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=web%20hosting%20control%20panel%20login%20screen%20on%20a%20desktop%20monitor%2C%20colorful%20icons%20dashboard%2C%20clean%20modern%20interface%20with%20brazilian%20portuguese%20labels%2C%20bright%20office&width=1200&height=675&seq=nx-blog-16&orientation=landscape",
    imageAlt: "Tela de acesso ao painel cPanel em um computador",
    intro: [
      "O cPanel é um dos painéis de hospedagem mais usados do mundo. Antes de gerenciar e-mails, bancos e arquivos, você precisa acessá-lo.",
      "Neste guia você aprende as formas de acesso ao cPanel e o que fazer quando o login não funciona.",
    ],
    content: [
      {
        id: "formas-acesso",
        heading: "Formas de acessar o cPanel",
        level: 2,
        list: [
          "Pelo endereço seudominio.com.br/cpanel.",
          "Pela porta segura fornecida pela hospedagem (ex.: seudominio.com.br:2083).",
          "Pelo painel do cliente, com um clique em Acessar cPanel.",
        ],
      },
      {
        id: "login",
        heading: "Fazendo login",
        level: 2,
        list: [
          "Abra o endereço de acesso no navegador.",
          "Informe o usuário e a senha da hospedagem.",
          "Clique em entrar para abrir o painel.",
        ],
      },
      {
        id: "esqueci-senha",
        heading: "Esqueci a senha",
        level: 2,
        paragraphs: [
          "A redefinição de senha é feita pelo painel do cliente da hospedagem ou com o suporte. Sempre que possível, use uma senha forte e única para o acesso.",
        ],
      },
      {
        id: "problemas",
        heading: "Problemas comuns de acesso",
        level: 2,
        list: [
          "Endereço incorreto: confirme o domínio e a porta.",
          "Usuário ou senha errados: revise os dados da contratação.",
          "Bloqueio temporário por tentativas: espere alguns minutos.",
          "Certificado: aceite o aviso na primeira conexão.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Com o acesso ao cPanel funcionando, você tem em mãos todas as ferramentas para administrar o seu site. É a porta de entrada da sua hospedagem.",
        ],
      },
    ],
    faqs: [
      {
        question: "Qual a diferença entre cPanel e o painel do cliente?",
        answer:
          "O painel do cliente é onde você gerencia as suas contratações e faturas. O cPanel é onde você administra o site, os e-mails e os arquivos.",
      },
      {
        question: "Posso acessar o cPanel pelo celular?",
        answer:
          "Sim. O cPanel funciona no navegador do celular, embora as telas maiores ofereçam mais conforto para as tarefas do dia a dia.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e encontre uma estrutura adequada para o seu projeto.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "como-criar-email-no-cpanel",
    title: "Como criar e-mail no cPanel",
    h1: "Como criar e-mail no cPanel?",
    excerpt:
      "Aprenda a criar e configurar contas de e-mail profissional no cPanel, com encaminhamento, autoresposta e boas práticas de entrega.",
    metaTitle: "Como Criar E-mail no cPanel | Guia NXHOST",
    metaDescription:
      "Passo a passo para criar e-mail profissional no cPanel, configurar encaminhamento, autoresposta e melhorar a entrega das mensagens.",
    focusKeyword: "como criar email no cpanel",
    keywords: ["criar email cpanel", "email profissional", "conta de email cpanel", "cpanel email"],
    category: "cpanel",
    level: "Iniciante",
    tags: ["cPanel", "Hospedagem", "Dominio"],
    author: "nxhost",
    publishedAt: "2026-05-28",
    updatedAt: "2026-09-16",
    readingTime: "6 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=email%20accounts%20management%20screen%20on%20a%20laptop%20with%20a%20list%20of%20professional%20domain%20emails%2C%20clean%20modern%20panel%20with%20brazilian%20portuguese%20labels%2C%20bright%20modern%20workspace&width=1200&height=675&seq=nx-blog-17&orientation=landscape",
    imageAlt: "Tela de contas de e-mail no painel cPanel",
    intro: [
      "Um e-mail com o domínio da empresa passa mais confiança do que endereços pessoais. No cPanel, criar essa conta é rápido.",
      "Neste tutorial você aprende a criar e-mails, configurar encaminhamento e autoresposta e cuidar da entrega das mensagens.",
    ],
    content: [
      {
        id: "criar",
        heading: "Como criar um e-mail no cPanel",
        level: 2,
        list: [
          "Na seção Email, clique em Email Accounts.",
          "Clique em Create para criar uma nova conta.",
          "Digite o nome (ex.: comercial), escolha o domínio e defina a senha.",
          "Clique em Create Account: a conta está pronta.",
        ],
      },
      {
        id: "webmail",
        heading: "Acessando pelo webmail",
        level: 2,
        paragraphs: [
          "Você pode enviar e receber mensagens direto pelo navegador, acessando o webmail pelo cPanel. É útil para consultas rápidas sem configurar um programa de e-mail.",
        ],
      },
      {
        id: "autoresposta",
        heading: "Autoresposta e encaminhamento",
        level: 2,
        list: [
          "Autoresposta: envia uma resposta automática para quem escreve.",
          "Forwarder: encaminha mensagens para outro endereço.",
          "Filtros: organizam as mensagens por assunto ou remetente.",
        ],
      },
      {
        id: "configurar",
        heading: "Configurando no seu programa",
        level: 2,
        list: [
          "Servidor de entrada: IMAP na porta 993 com SSL.",
          "Servidor de saída: SMTP na porta 587 com autenticação.",
          "Usuário: o endereço de e-mail completo.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Com as contas de e-mail criadas e configuradas no cPanel, a comunicação da sua empresa ganha profissionalismo. Cuide também de SPF, DKIM e DMARC para melhorar a entrega.",
        ],
      },
    ],
    faqs: [
      {
        question: "Qual a diferença entre IMAP e POP?",
        answer:
          "No IMAP as mensagens ficam no servidor e são sincronizadas entre dispositivos. No POP elas costumam ser baixadas para um único computador.",
      },
      {
        question: "Posso receber os e-mails no celular?",
        answer:
          "Sim. Configure a conta pelo IMAP ou pelo aplicativo de e-mail do celular usando os dados informados pela hospedagem.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e tenha e-mail profissional com o domínio da sua empresa.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "como-criar-banco-de-dados-mysql-no-cpanel",
    title: "Como criar banco de dados MySQL no cPanel",
    h1: "Como criar banco de dados MySQL no cPanel?",
    excerpt:
      "Aprenda a criar banco de dados e usuário MySQL no cPanel, atribuir permissões e acessar o phpMyAdmin para gerenciar os dados.",
    metaTitle: "Como Criar Banco de Dados MySQL no cPanel | NXHOST",
    metaDescription:
      "Passo a passo para criar banco de dados e usuário MySQL no cPanel, atribuir permissões e gerenciar tudo pelo phpMyAdmin.",
    focusKeyword: "como criar banco de dados mysql no cpanel",
    keywords: ["banco de dados cpanel", "mysql cpanel", "criar usuario mysql cpanel", "phpmyadmin"],
    category: "cpanel",
    level: "Iniciante",
    tags: ["cPanel", "MySQL", "Hospedagem"],
    author: "nxhost",
    publishedAt: "2026-06-02",
    updatedAt: "2026-09-17",
    readingTime: "7 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=mysql%20database%20creation%20wizard%20on%20a%20computer%20screen%20with%20tables%20and%20fields%2C%20clean%20modern%20panel%20with%20brazilian%20portuguese%20labels%2C%20bright%20tidy%20workspace&width=1200&height=675&seq=nx-blog-18&orientation=landscape",
    imageAlt: "Assistente de criação de banco de dados MySQL no cPanel",
    intro: [
      "Sites e sistemas precisam de um banco de dados para guardar conteúdos, produtos e usuários. No cPanel, esse processo é feito em poucos cliques.",
      "Neste tutorial você cria o banco, o usuário MySQL, atribui permissões e acessa o phpMyAdmin.",
    ],
    content: [
      {
        id: "criar-banco",
        heading: "Criando o banco de dados",
        level: 2,
        list: [
          "Na seção Databases, clique em MySQL Databases.",
          "Em Create New Database, informe o nome desejado.",
          "Clique em Create Database.",
        ],
      },
      {
        id: "criar-usuario",
        heading: "Criando o usuário MySQL",
        level: 2,
        list: [
          "Em MySQL Users, informe o nome do usuário e a senha.",
          "Clique em Create User.",
          "Em Add User To Database, selecione o usuário e o banco.",
          "Marque as permissões necessárias e confirme.",
        ],
      },
      {
        id: "phpmyadmin",
        heading: "Gerenciando pelo phpMyAdmin",
        level: 2,
        paragraphs: [
          "Com o phpMyAdmin você visualiza e edita as tabelas, importa e exporta dados e executa consultas. É a ferramenta mais prática para tarefas do dia a dia.",
        ],
      },
      {
        id: "conectar",
        heading: "Conectando o site ao banco",
        level: 2,
        list: [
          "Host: geralmente localhost.",
          "Nome do banco e do usuário: com o prefixo gerado pelo cPanel.",
          "Senha: a definida na criação do usuário.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Criar um banco de dados no cPanel é essencial para instalar e rodar sites, lojas e sistemas. Com banco e usuário configurados, basta conectar ao seu projeto.",
        ],
      },
    ],
    faqs: [
      {
        question: "O prefixo no nome do banco é obrigatório?",
        answer:
          "O cPanel adiciona automaticamente um prefixo ao nome do banco e do usuário. Use sempre o nome completo gerado no painel ao configurar o site.",
      },
      {
        question: "Posso importar um banco existente?",
        answer:
          "Sim. Pelo phpMyAdmin você importa arquivos .sql de bancos que já existem, útil ao migrar um site de outro servidor.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e encontre uma estrutura adequada para sites, sistemas e lojas virtuais.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "como-instalar-ssl-no-cpanel",
    title: "Como instalar SSL no cPanel",
    h1: "Como instalar SSL no cPanel?",
    excerpt:
      "Veja como ativar o certificado SSL gratuito no cPanel e colocar o seu site em HTTPS com poucos cliques.",
    metaTitle: "Como Instalar SSL no cPanel | HTTPS | NXHOST",
    metaDescription:
      "Aprenda a instalar e ativar o certificado SSL no cPanel, forçar o HTTPS e deixar o seu site seguro para os visitantes.",
    focusKeyword: "como instalar ssl no cpanel",
    keywords: ["ssl cpanel", "https cpanel", "certificado ssl", "autossl"],
    category: "cpanel",
    level: "Intermediário",
    tags: ["cPanel", "SSL", "Hospedagem"],
    author: "nxhost",
    publishedAt: "2026-06-06",
    updatedAt: "2026-09-18",
    readingTime: "6 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=ssl%20tls%20security%20panel%20in%20web%20hosting%20control%20panel%20with%20a%20green%20padlock%2C%20clean%20modern%20interface%20with%20brazilian%20portuguese%20labels%2C%20bright%20workspace&width=1200&height=675&seq=nx-blog-19&orientation=landscape",
    imageAlt: "Painel SSL/TLS do cPanel com certificado ativo",
    intro: [
      "O certificado SSL deixa o seu site seguro e mostra o cadeado aos visitantes. No cPanel, ativar o SSL é rápido e pode ser automático.",
      "Neste guia você aprende a emitir o certificado, forçar o HTTPS e verificar a renovação.",
    ],
    content: [
      {
        id: "por-que",
        heading: "Por que usar SSL",
        level: 2,
        paragraphs: [
          "Sem SSL, o navegador avisa que o site não é seguro. Isso afasta visitantes e prejudica a confiança. Com o HTTPS ativo, a conexão é criptografada e a experiência fica mais segura.",
        ],
      },
      {
        id: "autossl",
        heading: "Ativando o SSL no cPanel",
        level: 2,
        list: [
          "Na seção Security, acesse SSL/TLS Status.",
          "Selecione os domínios desejados.",
          "Clique em executar o AutoSSL para emitir o certificado gratuito.",
          "Aguarde a conclusão e verifique o status como ativo.",
        ],
      },
      {
        id: "forcar-https",
        heading: "Forçando o HTTPS",
        level: 2,
        paragraphs: [
          "Após emitir o certificado, ative o redirecionamento para HTTPS. Assim, quem acessa a versão sem cadeado é levado automaticamente para a versão segura.",
        ],
      },
      {
        id: "renovacao",
        heading: "Renovação automática",
        level: 2,
        paragraphs: [
          "O cPanel costuma renovar os certificados automaticamente. Vale conferir periodicamente se a renovação está ocorrendo sem erros.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Com o SSL ativo no cPanel, o seu site transmite segurança e ganha credibilidade. É um passo simples com impacto direto na percepção dos visitantes.",
        ],
      },
    ],
    faqs: [
      {
        question: "O SSL do cPanel é gratuito?",
        answer:
          "A maioria das hospedagens oferece o certificado gratuito via AutoSSL. O processo é automático e não tem custo adicional para o cliente.",
      },
      {
        question: "O HTTPS muda o endereço do site?",
        answer:
          "Não. O endereço continua o mesmo, apenas passa a usar https:// no início em vez de http://.",
      },
    ],
    cta: {
      title: "Precisa de uma hospedagem profissional?",
      text: "Conheça as soluções de hospedagem da NXHOST e tenha SSL, e-mail profissional e suporte incluso.",
      label: "Conhecer hospedagem",
      to: "/hospedagem",
    },
  },
  {
    slug: "como-instalar-wordpress-no-cpanel",
    title: "Como instalar WordPress no cPanel com Softaculous",
    h1: "Como instalar WordPress no cPanel?",
    excerpt:
      "Aprenda a instalar o WordPress no cPanel usando o Softaculous em poucos cliques e comece a publicar conteúdo.",
    metaTitle: "Como Instalar WordPress no cPanel | Softaculous | NXHOST",
    metaDescription:
      "Passo a passo para instalar o WordPress no cPanel com o Softaculous, configurar o site e começar a publicar conteúdo rapidamente.",
    focusKeyword: "como instalar wordpress no cpanel",
    keywords: ["wordpress cpanel", "softaculous", "instalar wordpress", "criar site wordpress"],
    category: "cpanel",
    level: "Iniciante",
    tags: ["cPanel", "WordPress", "Hospedagem"],
    author: "nxhost",
    publishedAt: "2026-06-10",
    updatedAt: "2026-09-19",
    readingTime: "7 min de leitura",
    image:
      "https://readdy.ai/api/search-image?query=one%20click%20wordpress%20installation%20wizard%20on%20a%20laptop%20screen%20with%20softaculous%20style%20interface%2C%20clean%20modern%20panel%20with%20brazilian%20portuguese%20labels%2C%20bright%20workspace&width=1200&height=675&seq=nx-blog-20&orientation=landscape",
    imageAlt: "Assistente de instalação do WordPress no cPanel",
    intro: [
      "O WordPress é a plataforma mais usada para criar sites e blogs. Com o Softaculous, presente em muitos cPanels, você instala tudo em poucos cliques.",
      "Neste tutorial você aprende a instalar o WordPress e configurar os primeiros passos do seu site.",
    ],
    content: [
      {
        id: "softaculous",
        heading: "O que é o Softaculous",
        level: 2,
        paragraphs: [
          "O Softaculous é um instalador de aplicações que automatiza a instalação do WordPress e de outros sistemas. Ele cria o banco de dados e os arquivos automaticamente.",
        ],
      },
      {
        id: "instalar",
        heading: "Instalando o WordPress",
        level: 2,
        list: [
          "No cPanel, acesse a seção Softaculous / WordPress.",
          "Clique em Instalar.",
          "Escolha o domínio e a pasta (deixe vazio para a raiz).",
          "Defina o nome do site, o usuário administrador, a senha e o e-mail.",
          "Clique em instalar e aguarde a conclusão.",
        ],
      },
      {
        id: "primeiros-passos",
        heading: "Primeiros passos no WordPress",
        level: 2,
        list: [
          "Acesse o painel em seudominio.com.br/wp-admin.",
          "Escolha um tema e ajuste a identidade visual.",
          "Crie as páginas principais (início, serviços, contato).",
          "Instale os plugins essenciais de SEO e segurança.",
        ],
      },
      {
        id: "seguranca",
        heading: "Segurança e atualizações",
        level: 2,
        paragraphs: [
          "Mantenha o WordPress, o tema e os plugins atualizados. Use senhas fortes e ative o SSL. Um backup recente garante que você consiga restaurar o site se algo der errado.",
        ],
      },
      {
        id: "conclusao",
        heading: "Conclusão",
        level: 2,
        paragraphs: [
          "Com o WordPress instalado pelo cPanel, você tem uma base completa para criar e gerenciar o seu site. A partir daí, é conteúdo, design e evolução constante.",
        ],
      },
    ],
    faqs: [
      {
        question: "Preciso saber programar para usar WordPress?",
        answer:
          "Não. O WordPress foi feito para ser usado por qualquer pessoa. Temas e plugins permitem montar o site sem escrever código.",
      },
      {
        question: "O WordPress é gratuito?",
        answer:
          "Sim, o WordPress é um software gratuito e de código aberto. Você paga apenas pela hospedagem e pelo domínio.",
      },
    ],
    cta: {
      title: "Quer colocar sua empresa na internet?",
      text: "A NXHOST desenvolve sites profissionais, responsivos e preparados para SEO, além de oferecer hospedagem para o seu projeto.",
      label: "Criar meu site",
      to: "/sites",
    },
  },
];